export default __webpack_public_path__ + "static/media/certificate-loading.fc1addae.png";